import * as React from 'react';
import { RenderTree } from "../../types/manage-users";
import { SimpleTreeView, useTreeViewApiRef } from '@mui/x-tree-view';
import RoleTreeItem from './RoleTreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';


const CustomExpandMoreIcon = () => <ExpandMoreIcon data-testid="expand-icon" />;
const CustomChevronRightIcon = () => <ChevronRightIcon data-testid="expand-icon" />;
interface Props {
    data: RenderTree[];
    setRoleTreeData?: Function;
}

const RoleTreeView: React.FunctionComponent<Props> = (props) => {

    const { data, setRoleTreeData } = props;
    const apiRef = useTreeViewApiRef();
    const [selectedItems, setSelectedItems] = React.useState<string[]>([]);
    const toggledItemRef = React.useRef<{ [itemId: string]: boolean }>({});    

    const handleItemSelectionToggle = (
        event: React.SyntheticEvent,
        itemId: string,
        isSelected: boolean,
    ) => {
        toggledItemRef.current[itemId] = isSelected;
    };

    const handleSelectedItemsChange = (
        event: React.SyntheticEvent,
        newSelectedItems: string[],
    ) => {
        setSelectedItems(newSelectedItems);
    };

    return (
        <SimpleTreeView
            multiSelect
            data-testid="advance-tree-view"
            aria-label="icon expansion"
            selectedItems={selectedItems}
            apiRef={apiRef}
            onItemSelectionToggle={handleItemSelectionToggle}
            onSelectedItemsChange={handleSelectedItemsChange}
            slots={{ expandIcon: CustomChevronRightIcon, collapseIcon: CustomExpandMoreIcon }}
            sx={{ minHeight: 200, flexGrow: 1, maxWidth: '100%', position: 'relative' }}>
            {data.map((item: any, index: number) => <RoleTreeItem key={index} data={item} index={index} setRoleTreeData={setRoleTreeData ?? (() => {})} />)}
        </SimpleTreeView>
    )
}

export default RoleTreeView;